// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"81860742","104":"d2063964","453":"54292a4b","466":"e181ce21","780":"0927afc3"}[chunkId] + ".chunk.js";
};